export default "__VITE_ASSET__ClF9XwiD__"